export default __webpack_public_path__ + "static/about-us-1-371a5eacdc3d81141cf972ca0c83d5b8.png";